var exports = {
  "k": "xe564cbfb--8f8689--container",
  "A": "xe564cbfb--8f8689--subtitles",
};

module.exports = exports;
